import { call, take, put, cancel, fork } from 'redux-saga/effects';
import { ACTIONS } from '../actions/actionTypes';

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

export function * TICK () {
    while (true) {
        yield call(delay, 1000);
        yield put({ type: ACTIONS.TICK_TIMER });
    }
};

export function * TIMER () {
    while (yield take(ACTIONS.START_TIMER)) {
        const bgSyncTask = yield fork(TICK);
        yield take(ACTIONS.STOP_TIMER);
        yield cancel(bgSyncTask);
    }
};



// WEBPACK FOOTER //
// ./src/sagas/timeSaga.js